import FavoriteButtonContainer from './FavoriteButtonContainer';
import FavoriteButton from './FavoriteButton';

export default FavoriteButtonContainer(FavoriteButton);
